"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "main-nav-menu-list"
  }, children);
};